// Legenda: gruppi di layer accendibili, con elenco delle zone (swatch) e filtro.

import React, { useMemo, useState } from "react";
import Icon from "./Icon";
import { Check, Panel, Swatch } from "./ui";

function GroupItems({ group, filter, onToggleItem, onSetItems }) {
  const items = useMemo(() => {
    const f = filter.trim().toLowerCase();
    return f ? group.items.filter((i) => i.label.toLowerCase().includes(f)) : group.items;
  }, [group.items, filter]);
  if (!items.length) return <p className="sm-panel-text sm-muted" style={{ paddingLeft: 22 }}>Nessuna zona corrisponde.</p>;
  return (
    <div className="sm-legend-items">
      {onSetItems && (
        <div className="sm-list-actions" style={{ padding: "2px 0 4px" }}>
          <button type="button" className="sm-link" onClick={() => onSetItems(group.id, true, items)}>Tutte</button>
          <button type="button" className="sm-link" onClick={() => onSetItems(group.id, false, items)}>Nessuna</button>
        </div>
      )}
      {items.map((it) => (
        <Check key={it.id} checked={it.visible} onChange={() => onToggleItem(group.id, it.id)}>
          <Swatch swatch={it.swatch} />
          <span className="sm-legend-label" title={it.label}>{it.label}</span>
        </Check>
      ))}
    </div>
  );
}

export default function LegendPanel({
  title = "Legenda",
  groups,
  onToggleGroup,
  onToggleItem,
  onSetItems,
  filterable,
  defaultExpanded = false,
  onClose,
  children,
}) {
  const [filter, setFilter] = useState("");
  const [expanded, setExpanded] = useState(() => new Set(defaultExpanded ? groups.map((g) => g.id) : []));
  const toggleExpanded = (id) =>
    setExpanded((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });

  return (
    <Panel title={title} onClose={onClose} wide>
      {children}
      {filterable && (
        <input
          className="sm-input"
          placeholder="Filtra le zone…"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
      )}
      <div className="sm-scroll-list" style={{ maxHeight: "calc(100vh - 340px)" }}>
        {groups.length === 0 && <p className="sm-panel-text sm-muted">Nessun livello disponibile.</p>}
        {groups.map((g) => {
          const open = expanded.has(g.id) || !!filter.trim();
          return (
            <div key={g.id} className="sm-legend-group">
              <div className="sm-legend-group-head">
                <Check checked={g.visible} onChange={() => onToggleGroup(g.id)}>
                  <span className="sm-legend-label" title={g.name}>{g.name}</span>
                  {g.items && <span className="sm-muted" style={{ fontWeight: 400 }}>({g.items.length})</span>}
                </Check>
                {g.items?.length > 0 && (
                  <button
                    type="button"
                    className="sm-icon-btn"
                    style={{ width: 26, height: 26 }}
                    aria-label={open ? "Comprimi" : "Espandi"}
                    title={open ? "Comprimi" : "Espandi"}
                    onClick={() => toggleExpanded(g.id)}
                  >
                    <Icon name="chevron-down" size={14} style={{ transform: open ? "rotate(180deg)" : "none" }} />
                  </button>
                )}
              </div>
              {open && g.items && (
                <GroupItems group={g} filter={filter} onToggleItem={onToggleItem} onSetItems={onSetItems} />
              )}
            </div>
          );
        })}
      </div>
    </Panel>
  );
}
